import { Injectable } from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, take } from 'rxjs/operators'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { MatSnackBar } from '@angular/material/snack-bar'
import { TranslateService } from '@ngx-translate/core'
import * as UserActions from '@store/user.actions'
import { selectCurrentUser } from '@store/user.selectors'

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private store: Store,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Authentication uses httpOnly cookies sent automatically by the browser.
    // No token is read from localStorage here to avoid XSS exposure.
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 401 && !this.isLoginRequest(req)) {
          this.handleSessionExpired()
        }

        return throwError(() => error)
      })
    )
  }

  private handleSessionExpired(): void {
    // Only tell the user their session "expired" if they actually had one —
    // an anonymous visitor hitting a protected route shouldn't see that toast.
    this.store
      .select(selectCurrentUser)
      .pipe(take(1))
      .subscribe((currentUser) => {
        if (currentUser) {
          this.snackBar.open(
            this.translate.instant('errors.sessionExpired'),
            'Dismiss',
            { duration: 4000, horizontalPosition: 'center', verticalPosition: 'top' }
          )
        }

        this.store.dispatch(UserActions.clearCurrentUser())
        this.router.navigate(['/login'])
      })
  }

  private isLoginRequest(req: HttpRequest<any>): boolean {
    return req.url.endsWith('/login')
  }
}
